export const userRoles = [
    'admin',
    'systemadmin',
    'teamlead',
    'agent',
    'enduser',
];
